<script>
import { LINE_PATH_CONFIG } from "./GoogleMapSettings";

export default {
  name: "GoogleMapPolygon",
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    path: {
      type: Array,
      required: true,
    },
    options: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },
  mounted() {
    const { Polygon } = this.google.maps;
    this.polygon = new Polygon({
      path: this.path,
      map: this.map,
      ...LINE_PATH_CONFIG,
      ...this.options,
    });
  },
  // eslint-disable-next-line vue/require-render-return
  render() {},
};
</script>
